import React from "react";
import theme from "Theme/AppTheme";
import AcxMainTextField, {
    AcxMainTextFieldRef,
} from "components/UI/AcxMainTextField";
import { UserWithFullName } from "components/Signals/Dashboard/DashboardMenu/ShareDialog/constants";
import CommentComposerBase from "./CommentComposerBase";

type EditComposerProps = {
    value: string;
    isSaving: boolean;
    inputRef: React.RefObject<AcxMainTextFieldRef>;
    onChange: (
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    ) => void;
    inputProps: React.ComponentProps<typeof AcxMainTextField>["inputProps"];
    onCancel: () => void;
    onSubmit: () => void;
    mentionDropdown: React.ReactNode;
    mentionSelections: UserWithFullName[];
};

const EditComposer = ({
    value,
    isSaving,
    inputRef,
    onChange,
    inputProps,
    onCancel,
    onSubmit,
    mentionDropdown,
    mentionSelections,
}: EditComposerProps) => (
    <CommentComposerBase
        inputId="edit-comment-composer-text-input"
        placeholderText="Edit your comment"
        value={value}
        inputRef={inputRef}
        onChange={onChange}
        inputProps={inputProps}
        mentionDropdown={mentionDropdown}
        mentionSelections={mentionSelections}
        actionJustify="flex-end"
        onCancel={onCancel}
        onSubmit={onSubmit}
        primaryLabel={isSaving ? "Saving..." : "Save"}
        secondaryLabel="Cancel"
        primaryButtonId="comment-edit"
        disablePrimary={!value.trim() || isSaving}
        containerBackground={theme.palette.gray[50]}
        inputBackground={theme.palette.white.main}
    />
);

export default EditComposer;
